import { IRequirement } from "../pages/Project";
import IStatusImpediment from "../interfaces/IStatusImpediment";

const isWarningActivity = (requirements: IRequirement[]): boolean => {
  if (!requirements) {
    return false;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < requirements.length; i++) {
    const requirement = requirements[i];
    if (
      requirement.comments?.some(
        comment => comment.status === IStatusImpediment.warning,
      )
    ) {
      return true;
    }
  }

  return false;
};

export default isWarningActivity;
